import axios from 'axios';
import * as environment from './environment.js';

export function getFromServer(relativePath,successCallback, errorCallback,noPermissionCallback) {
    var config = {
        headers: {'X-Custom-Referer': window.location.host,
            'X-Custom-Is-Impersion': localStorage.getItem('isImpersonate'),
            'X-Custom-Impersonated-Affiliate': localStorage.getItem('impersonatedAffiliate')},
        withCredentials:true
    };

    axios.get(environment.getServerBasePath() + "/" + relativePath,config)
        .then(successCallback).catch(function (error) {

         if (error.response && error.response.status === 403) {

             noPermissionCallback && noPermissionCallback();

         }
         else {
             //console.log('error callback');
             errorCallback && errorCallback(error);
         }

    });
}

export function postToServer(relativePath,data,successCallback, errorCallback,noPermissionCallback) {
    const config = {
        headers: {'X-Custom-Referer': window.location.host,
            'X-Custom-Is-Impersion': localStorage.getItem('isImpersonate'),
            'X-Custom-Impersonated-Affiliate': localStorage.getItem('impersonatedAffiliate')},
        withCredentials:true
    };

    axios.defaults.withCredentials = true;

    return axios.post(environment.getServerBasePath() + "/" + relativePath,data,config)
        .then(successCallback).catch(function (error) {

        if (error.response && error.response.status === 403) {

            if (noPermissionCallback) {
                noPermissionCallback(error.response);
            }
            else{
                //Invoke the error callback when there is no permission, and no permission callback supplied
                errorCallback && errorCallback(error.response);
            }

        }
        else {
            errorCallback && errorCallback(error.response);
        }

    });
}
